import { render, staticRenderFns } from "./RootTipiTariffaView.vue?vue&type=template&id=94f6385e&"
import script from "./RootTipiTariffaView.vue?vue&type=script&lang=ts&"
export * from "./RootTipiTariffaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports